// extracted by mini-css-extract-plugin
export default {"column":"Countdown_column__Flgbc","columnElement":"Countdown_columnElement__MUvV1","columnElementNumber":"Countdown_columnElementNumber__xuwBi"};